import { IntegrationAuthApp } from '@/levity/integrations/types';
import { compose } from '@/utils/functions';

import type { FlowTemplate } from '../types';
import * as frontTemplates from './front';
import * as gmailTemplates from './gmail';
import * as outlookTemplates from './outlook';
import * as zendeskTemplates from './zendesk';

export const templates: Record<IntegrationAuthApp, Record<string, FlowTemplate>> = {
  [IntegrationAuthApp.gmailV1]: gmailTemplates,
  [IntegrationAuthApp.microsoftTeams]: {},
  [IntegrationAuthApp.microsoftTeamsV2]: outlookTemplates,
  [IntegrationAuthApp.zendeskV1]: zendeskTemplates,
  [IntegrationAuthApp.gsheetsV1]: {},
  [IntegrationAuthApp.frontV1]: frontTemplates,
  [IntegrationAuthApp.hubspotV1]: {},
  [IntegrationAuthApp.slack]: {},
  [IntegrationAuthApp.network]: {},
  [IntegrationAuthApp.webhook]: {},
  [IntegrationAuthApp.customCode]: {},
  [IntegrationAuthApp.freshdeskV1]: {},
  [IntegrationAuthApp.freshserviceEnpal]: {},
  [IntegrationAuthApp.development]: {},
  [IntegrationAuthApp.gw]: {},
  [IntegrationAuthApp.microsoftEntra]: {},
};

export const featureFlagTemplates = ({
  gsheets,
  internalTemplates,
}: {
  gsheets?: string | boolean;
  internalTemplates?: string | boolean;
}) => {
  const featureFlagGSheets = (templates: Record<IntegrationAuthApp, Record<string, FlowTemplate>>) =>
    gsheets ? { ...templates } : { ...templates, [IntegrationAuthApp.gsheetsV1]: {} };

  const featureFlagInternalTemplates = (templates: Record<IntegrationAuthApp, Record<string, FlowTemplate>>) =>
    internalTemplates
      ? { ...templates }
      : {
          ...templates,
          [IntegrationAuthApp.slack]: {},
          [IntegrationAuthApp.development]: {},
        };

  const createFlowTemplates = compose(featureFlagInternalTemplates, featureFlagGSheets);

  const flowTemplates = createFlowTemplates(templates);

  return flowTemplates;
};
